var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"chartRef",staticClass:"chart",attrs:{"id":"direct"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }